import React, { Component, PropTypes } from 'react';
import { Link } from 'react-router';
import GWESlider from './GWESlider';


class GWEPromo extends Component {
  constructor(props) {
    super(props);
  }

  render() {






    return(
      <div className="festival-gwePromoWrapper">
        <div className="headerWrapper">
          <h2>Find a Girls World Expo in a city near you</h2>
          <p>WorldWideWomen is merging with Girls World Expo to create a national program of events to connect and empower girls around the country. Take a look at our 2019 line up of expos and sign up for a very fun and powerful day!</p>
        </div>
        <div className="festival-gwePromoImgWrapper"><a href="https://www.girlsworldexpo.com" target="_blank"><img src="/images/festival/home/2019/gwe/GWE_banner_V12.jpg" /></a></div>
        <GWESlider
          browser = {this.props.browser}
        />
      </div>
    );
  }
}

export default GWEPromo;



// WEBPACK FOOTER //
// ./src/components/festival/gwe/GWEPromo.jsx